/**
 * 404 Not Found page.
 * Displays a minimal error message with a link back to the homepage.
 * Logs the attempted route to the console for debugging.
 */
import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import useDocumentMeta from "@/hooks/useDocumentMeta";

const NotFound = () => {
  const location = useLocation();

  useDocumentMeta({
    title: "Page Not Found – Thursday Jam",
    description: "The page you're looking for doesn't exist. Return to Thursday Jam's homepage.",
    robots: "noindex, follow",
  });

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <main id="main-content" className="flex min-h-screen items-center justify-center bg-background">
      <div className="text-center px-6">
        <h1 className="mb-4 font-display text-8xl tracking-tight text-foreground">404</h1>
        <p className="mb-8 text-xl text-muted-foreground">This page doesn't exist</p>
        <Link 
          to="/" 
          className="inline-block font-display text-sm uppercase tracking-[0.2em] text-foreground border border-foreground px-8 py-3 hover:bg-foreground hover:text-background transition-colors"
        >
          Back to Home
        </Link>
      </div>
    </main>
  );
};

export default NotFound;
